export const API = "http://localhost:5000" || "https://exampleurlhere";
